import { states } from '../data/data';

export default {
    items: [
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'address',
                    width: 12,
                    props: {
                        label: 'Address'
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'city',
                    width: 6,
                    props: {
                        label: 'City'
                    }
                },
                {
                    type: 'selectlist',
                    name: 'state',
                    width: 4,
                    props: {
                        items: states,
                        label: 'State'
                    }
                },
                {
                    type: 'text-field',
                    name: 'zip',
                    width: 2,
                    props: {
                        label: 'Zip'
                    }
                },
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'selectlist',
                    name: 'primary-use',
                    width: 6,
                    props: {
                        label: 'Primary Use',
                        items: [
                            {
                                text: 'Client Meetings',
                                value: 'client-meetings'
                            },
                            {
                                text: 'Client Meetings + Staff',
                                value: 'client-meetings-staff'
                            },
                            {
                                text: 'Registered Office',
                                value: 'registered-office'
                            },
                            {
                                text: 'Satellite Office',
                                value: 'satellite-office'
                            },
                            {
                                text: 'Staff',
                                value: 'staff'
                            },
                            {
                                text: 'Other',
                                value: 'other'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'radio-list',
                    name: 'primary-location',
                    width: 12,
                    props: {
                        label: 'Is this the primary address?',
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    }
                }
            ]
        },
    ]
};


// WEBPACK FOOTER //
// ./src/components/valuation/data_table_forms/office-address.js